import { createAxiosLogistica } from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";

export const logisticaValoracionService = {
  getValoraciones,
  revalorar,
  generarAlbaranes,
};

function getValoraciones(pagination, filters) {
  const usuario = JSON.parse(localStorage.getItem("user"));
  if (usuario.agrupacion)
    filters.franquicia = franquiciaService.getLocalFranquicia()._id;
  const axios = createAxiosLogistica();
  let urlPath = `logistica/valoracion`;
  const params = new URLSearchParams({ ...pagination, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function revalorar(body) {
  const usuario = JSON.parse(localStorage.getItem("user"));
  if (usuario.agrupacion)
    body.franquicia = franquiciaService.getLocalFranquicia()._id;

  const axios = createAxiosLogistica();
  let urlPath = `logistica/valoracion/revalorar`;
  const params = new URLSearchParams(body);

  urlPath += `?${params.toString()}`;
  return axios.post(urlPath);
}

function generarAlbaranes(body) {
  const usuario = JSON.parse(localStorage.getItem("user"));
  if (usuario.agrupacion)
    body.franquicia = franquiciaService.getLocalFranquicia()._id;

  const axios = createAxiosLogistica();
  let urlPath = `logistica/valoracion/albaranes`;
  const params = new URLSearchParams(body);

  urlPath += `?${params.toString()}`;
  return axios.post(urlPath);
}
